import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-center flex-shrink-0 w-12 h-12 mx-auto mb-2 rounded-full bg-primary-300" }
const _hoisted_2 = { class: "text-sm leading-5 text-center text-gray-500" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "w-full mx-auto mb-3" }
const _hoisted_5 = { class: "flex justify-center space-x-3 mt-3" }
const _hoisted_6 = { class: "flex justify-between space-x-3 mt-9" }

import { ref } from "vue";

import {
  DialogTitle,
} from '@headlessui/vue';
import BaseModal from '@/components/modals/BaseModal.vue';
import ButtonComponent from '@/components/buttons/ButtonComponent.vue';
import lockCircleIcon from "@/components/icons/lockCircleIcon.vue";
import PasswordInput from "@/components/inputs/PasswordInput.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SecurityFeatureForm',
  props: {
    show: {
        type: Boolean
    },
    title: {
        type: String,
    },
    content: {
        type: String,
    },
    actionText: {
        type: String,
    },
    customClass: {
        type: String,
        default: 'py-6 px-6 w-[480px]'
    },
    whiteBg: {
        type: Boolean,
        default: false
    },
    validate: {
        type: Boolean,
        default: true
    },
    isNetworkAvailable: {
        type: Boolean,
        default: true,
    },
    password: {
        type: String,
        default: null,
    },
    error: {
        type: String,
        default: null,
    }
},
  emits: ['confirm'],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const props = __props

const password = ref(props.password);

const confirm = (): void => {
    if (!password.value) {
        return;
    }
    emit('confirm', password.value); 
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseModal, {
    customClass: __props.customClass,
    show: __props.show,
    whiteBg: __props.whiteBg
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(lockCircleIcon, { class: "object-contain w-6 h-6" })
      ]),
      _createVNode(_unref(DialogTitle), {
        as: "p",
        class: "text-xl font-bold text-center text-neutral-900 focus-visible:outline-none",
        tabindex: "0"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(__props.title), 1)
        ]),
        _: 1
      }),
      _createElementVNode("form", {
        class: "flex flex-col space-y-6",
        onSubmit: _withModifiers(confirm, ["prevent"])
      }, [
        _createElementVNode("div", _hoisted_2, [
          (__props.content)
            ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(__props.content), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(PasswordInput, {
                name: "password",
                id: "password",
                placeholder: "Password",
                modelValue: password.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((password).value = $event))
              }, null, 8, ["modelValue"])
            ])
          ]),
          (__props.error)
            ? (_openBlock(), _createElementBlock("p", {
                key: 1,
                class: _normalizeClass(["text-[10px] mt-1 text-left", __props.error ? 'text-red-600' : 'text-gray-800']),
                id: "email-error"
              }, _toDisplayString(__props.error), 3))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(ButtonComponent, {
            disabled: !password.value,
            type: "submit",
            size: "large",
            btnWidth: "w-full",
            onClick: confirm
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.actionText), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ], 32)
    ]),
    _: 1
  }, 8, ["customClass", "show", "whiteBg"]))
}
}

})